import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import SvgIcon from '@material-ui/core/SvgIcon';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ChevronIcon from 'moods-stylesheets/src/icons/icon__ui--chevron-down-xbold.svg';
import CloseIcon from 'moods-stylesheets/src/icons/icon__ui--close-xbold.svg';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import moods from '../moods-theme';

const theme = createTheme(moods);

export function AutocompleteDropdown({ values = [], value, onChange, noOptionsText }) {
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  return (
    <ThemeProvider theme={theme}>
      <Autocomplete
        style={{ flex: 'inline-flex' }}
        options={values}
        // eslint-disable-next-line react/jsx-props-no-spreading
        renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
        closeIcon={<SvgIcon component={CloseIcon} viewBox="0 0 48 48" style={{ width: 18, height: 18 }} />}
        popupIcon={<SvgIcon component={ChevronIcon} viewBox="0 0 48 48" />}
        value={selectedValue}
        getOptionLabel={(option) => option.label}
        onChange={(e, itemValue) => {
          setSelectedValue(itemValue);
          onChange(itemValue);
        }}
        noOptionsText={noOptionsText}
      />
    </ThemeProvider>
  );
}
